module.exports = __webpack_public_path__ + "media/app/containers/OrderDetailsPage/Edit.e9a059a9.svg";